import { render, staticRenderFns } from "./HBarChart.vue?vue&type=template&id=c0cc56c8&scoped=true&"
import script from "./HBarChart.vue?vue&type=script&lang=js&"
export * from "./HBarChart.vue?vue&type=script&lang=js&"
import style0 from "./HBarChart.vue?vue&type=style&index=0&id=c0cc56c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0cc56c8",
  null
  
)

export default component.exports